import { searchIntents, safetyNotes } from '@/mocks/seo';

export default function TrustSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              Safety, Transparency &amp; Reliability
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 font-sans leading-relaxed">
              We prioritize transparency in all <strong>Mulebuy spreadsheet resources</strong>. Important considerations to keep in mind:
            </p>
            <ul className="mt-6 space-y-3">
              {safetyNotes.map((note) => (
                <li key={note} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0 mt-0.5">
                    <i className="ri-information-line text-accent-600 text-xs"></i>
                  </div>
                  <span className="text-sm text-foreground-600 font-sans">{note}</span>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-sm text-foreground-500 font-sans">
              We provide only <strong>structured informational Mulebuy spreadsheet content</strong>, not financial or transactional services.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              Why Users Search for Mulebuy Spreadsheet
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 font-sans leading-relaxed">
              This website is designed to fully cover all <strong>Mulebuy spreadsheet search intent clusters</strong> in one place.
            </p>
            <ul className="mt-6 space-y-3">
              {searchIntents.map((intent, i) => (
                <li key={intent} className="flex items-center gap-3 p-3 bg-background-100 rounded-lg border border-background-200">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 text-xs font-bold flex-shrink-0">
                    {i + 1}
                  </span>
                  <span className="text-sm text-foreground-700 font-sans font-medium">&ldquo;{intent}&rdquo;</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}